module.exports = __webpack_public_path__ + "static/media/panda-tronic.2025e43c.png";